import React, {Component} from 'react';
import axios from 'axios';
import {Card, CardBody, CardHeader, Table} from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
    FaCalendar,
    FaCloud,
    FaComment,
    FaDollarSign,
    FaUsers
} from "react-icons/fa";
import { Scrollbars } from 'react-custom-scrollbars';
import {Pie} from "react-chartjs-2";
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";
let iconStyles = { color: 'rgb(106, 130, 251, 0.8)', fontSize: '1.8em' };

class HomePage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            home: {},
            isLoadNearly: false,
            serviceNearly: {},
            dataChartVps: {},
            dataChartProxy: {},
            dataChartCredit: {},
            successNotification: false,
            messageSuccessNotification: '',
            errorNotification: false,
            messageErrorNotification: ''
        }
    }

    async componentDidMount() {
        // document.querySelector('.cr-sidebar').classList.add('cr-sidebar--open');
        window.scrollTo(0, 0);

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
            errorNotification: this.props.errorNotificationUser,
            messageErrorNotification: this.props.messageErrorNotificationUser,
            successNotification: this.props.successNotificationUser,
            messageSuccessNotification: this.props.messageSuccessNotificationUser,
        })
        if (this.props.isNotification) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
        if (this.props.errorNotificationUser) {
            this.props.updateErrorNotiUser({
                error: false,
                message: ''
            });
        }
        if (this.props.successNotificationUser) {
            this.props.updateSuccessNotiUser({
                success: false,
                message: ''
            });
        }
        await this.loadMenuCustomer();
        await this.getHomePage();
        await this.getServiceNearly();
    }

    loadMenuCustomer = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/home/getMenuCustomer',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log("1");
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.props.updateMenuCustomer( ref.data.menu_customer );
                } else {
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
            })
    }

    getHomePage = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/home/getHomePage',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log("2");
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    let dataChartVps = {};
                    let dataChartProxy = {};
                    if ( !ref.data.content.service.vps.error ) {
                        dataChartVps = {
                            labels: ['Còn hạn', 'Hết hạn', 'Hủy/xóa/chuyển'],
                            datasets: [
                                {
                                    label: 'Biểu đồ dịch vụ VPS',
                                    data: [ ref.data.content.service.vps.on, ref.data.content.service.vps.expire, ref.data.content.service.vps.cancel ],
                                    backgroundColor: [
                                        'rgba(75, 192, 192, 0.6)',
                                        'rgba(255, 99, 132, 0.6)',
                                        'rgba(255, 206, 86, 0.6)',
                                    ],
                                    borderColor: [
                                        'rgba(75, 192, 192, 1)',
                                        'rgba(255, 99, 132, 1)',
                                        'rgba(255, 206, 86, 1)',
                                    ],
                                    borderWidth: 1,
                                },
                            ],
                        }
                    }

                    if ( !ref.data.content.service.proxy.error ) {
                        dataChartProxy = {
                            labels: ['Còn hạn', 'Hết hạn', 'Hủy/xóa/chuyển'],
                            datasets: [
                                {
                                    label: 'Biểu đồ dịch vụ Proxy',
                                    data: [ ref.data.content.service.proxy.on, ref.data.content.service.proxy.expire, ref.data.content.service.proxy.cancel ],
                                    backgroundColor: [
                                        'rgba(75, 192, 192, 0.6)',
                                        'rgba(255, 99, 132, 0.6)',
                                        'rgba(255, 206, 86, 0.6)',
                                    ],
                                    borderColor: [
                                        'rgba(75, 192, 192, 1)',
                                        'rgba(255, 99, 132, 1)',
                                        'rgba(255, 206, 86, 1)',
                                    ],
                                    borderWidth: 1,
                                },
                            ],
                        }
                    }

                    let dataChartCredit = {
                        labels: ['Số dư', 'Đã dùng'],
                        datasets: [
                            {
                                label: 'Biểu đồ số dư tài khoản',
                                data: [ ref.data.content.credit.credit, ref.data.content.credit.total_total_expenses ],
                                backgroundColor: [
                                    'rgba(75, 192, 192, 0.6)',
                                    'rgba(255, 206, 86, 0.6)',
                                ],
                                borderColor: [
                                    'rgba(75, 192, 192, 1)',
                                    'rgba(255, 206, 86, 1)',
                                ],
                                borderWidth: 1,
                            },
                        ],
                    }

                    this.setState({
                        home: ref.data.content,
                        loadPage: false,
                        isLoading: false,
                        dataChartVps: dataChartVps,
                        dataChartProxy: dataChartProxy,
                        dataChartCredit: dataChartCredit,
                    })

                    let item = {
                        credit: ref.data.content.credit.credit
                    }
                    this.props.updateCredit(item);
                    // console.log(ref.data.content.service.menu_customer)
                    // this.props.updateMenuCustomer( ref.data.content.service.menu_customer );
                } else {
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu thất bại',
                })
            })
    }

    getServiceNearly = () => {
        this.setState({
            isLoadNearly: true
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/home/getServiceNearly',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        serviceNearly: ref.data.content,
                        isLoadNearly: false,
                    })
                } else {
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            isLoadNearly: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoadNearly: false,
                    error: true,
                    messageError: 'Lấy dữ liệu dịch vụ gần hết hạn thất bại',
                })
            })
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    ScrollbarsService = () => {
        // console.log(this.state.home.service)
        return (
            <Scrollbars style={{ width: 'auto', height: 250 }}>
                {/*VPS*/}
                {
                    !this.state.home.service.vps.error ? (
                        <div className="service_info mb-2">
                            <div className="col-12 home-mobile-repon mb-2">
                                <b>VPS VN</b>
                            </div>
                            {/*dang sử dụng*/}
                            <div className="col-4 home-mobile-repon">Tổng</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.vps.using }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-vps/dang-su-dung.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                            {/*còn hạn*/}
                            <div className="col-4 home-mobile-repon">Còn hạn</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.vps.on }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-vps/con-han.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                            {/*hết hạn*/}
                            <div className="col-4 home-mobile-repon">Hết hạn</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.vps.expire }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-vps/da-het-han.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
                {/*VPS US*/}
                {
                    !this.state.home.service.vps_us.error ? (
                        <div className="service_info mb-2">
                            <div className="col-12 home-mobile-repon mb-2">
                                <b>VPS US</b>
                            </div>
                            {/*dang sử dụng*/}
                            <div className="col-4 home-mobile-repon">Tổng</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.vps_us.using }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="dich-vu-vps-us/dang-su-dung.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                            {/*còn hạn*/}
                            <div className="col-4 home-mobile-repon">Còn hạn</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.vps_us.on }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-vps-us/con-han.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                            {/*hết hạn*/}
                            <div className="col-4 home-mobile-repon">Hết hạn</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.vps_us.expire }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-vps-us/da-het-han.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
                {/*  Cloud Server  */}
                {
                    !this.state.home.service.cloud_server.error ? (
                        <div className="service_info mb-2">
                            <div className="col-12 home-mobile-repon mb-2">
                                <b>Cloud Server</b>
                            </div>
                            {/*dang sử dụng*/}
                            <div className="col-4 home-mobile-repon">Tổng</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.cloud_server.using }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-vps/dang-su-dung.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                            {/*còn hạn*/}
                            <div className="col-4 home-mobile-repon">Còn hạn</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.cloud_server.on }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-vps/con-han.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                            {/*hết hạn*/}
                            <div className="col-4 home-mobile-repon">Hết hạn</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.cloud_server.expire }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-vps/da-het-han.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
                {/*Proxy*/}
                {
                    !this.state.home.service.proxy.error ? (
                        <div className="service_info mb-2">
                            <div className="col-12 home-mobile-repon mb-2">
                                <b>Proxy</b>
                            </div>
                            {/*dang sử dụng*/}
                            <div className="col-4 home-mobile-repon">Tổng</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.proxy.using }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="dich-vu-proxy/dang-su-dung.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                            {/*còn hạn*/}
                            <div className="col-4 home-mobile-repon">Còn hạn</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.proxy.on }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-proxy/con-han.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                            {/*hết hạn*/}
                            <div className="col-4 home-mobile-repon">Hết hạn</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.proxy.expire }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-proxy/da-het-han.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
                {/*  Hosting  */}
                {
                    !this.state.home.service.hosting.error ? (
                        <div className="service_info mb-2">
                            <div className="col-12 home-mobile-repon mb-2">
                                <b>Hosting</b>
                            </div>
                            {/*dang sử dụng*/}
                            <div className="col-4 home-mobile-repon">Tổng</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.hosting.using }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-vps/dang-su-dung.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                            {/*còn hạn*/}
                            <div className="col-4 home-mobile-repon">Còn hạn</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.hosting.on }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-vps/con-han.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                            {/*hết hạn*/}
                            <div className="col-4 home-mobile-repon">Hết hạn</div>
                            <div className="col-4 home-mobile-repon">{ this.state.home.service.hosting.expire }</div>
                            <div className="col-4 text-right home-mobile-repon mb-1">
                                <Link to="/dich-vu-vps/da-het-han.html" className="btn btn-secondary btn-sm btn-detail-static">Chi tiết</Link>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
            </Scrollbars>
        )
    }

    ScrollbarsNotification = () => {
        if (this.props.notifications.length) {
            return (
                <Scrollbars style={{ width: 'auto', minHeight: 250 }}>
                    {
                        this.props.notifications.map( (notification, key) => (
                            <li className="timeline-inverted" key={key}>
                                <Link to={"/thong-bao/" + notification.id + "/chi-tiet-thong-bao.html"}>
                                    <div className="timeline-panel">
                                        <div className="timeline-title">
                                            {
                                                notification.title
                                            }
                                            <br />
                                            <span className="text-domain">Ngày tạo: { notification.text_created_at }</span>
                                        </div>
                                    </div>
                                </Link>
                            </li>
                        ))
                    }
                </Scrollbars>
            )
        }
    }

    createMarkup = (title) => {
        return (
              title.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, "")
        )
    }

    loadHompageRight = () => {
        // console.log(this.props.notifications)
        return (
            <div className="row">
                <div className="col-xl-12 col-md-12">
                    <Card>
                        <CardHeader className="font-weight-bold">
                            Thông tin cá nhân
                        </CardHeader>
                        
                        <CardBody className="py-2">
                            <ul className="list-group list-group-flush">
                            <li className="list-group-item py-1 px-0">Họ và tên: { this.props.user.name }</li>
                            <li className="list-group-item py-1 px-0">Email: { this.props.user.email }</li>
                            <li className="list-group-item py-1 px-0">Đặc quyền: { this.props.user.text_role } </li>
                            <li className="list-group-item py-1 px-0">Số dư tài khoản: { this.addCommas( this.props.credit ) } ₫</li>
                            <li className="list-group-item py-1 px-0">Tổng tiền đã chi: { this.addCommas( this.state.home.credit.total_total_expenses ) } ₫</li>
                            <li className="list-group-item py-1 px-0">Tổng tiền đã nạp: { this.addCommas( this.state.home.credit.total ) } ₫</li>
                        </ul>
                        </CardBody>
                    </Card>
                </div>
                <div className="col-xl-12 col-md-12">
                    <Card>
                        <CardHeader className="font-weight-bold">
                            {
                                this.props.notifications.length ? (
                                    <>
                                        <span className="ml-2 mt-2">
                                            Có { this.props.unread_notification } thông báo mới
                                         </span>
                                        <Link to="/thong-bao/danh-sach-thong-bao.html">
                                             <span className="d-inline badge badge-primary ml-2">
                                                 Chi tiết
                                             </span>
                                        </Link>
                                    </>
                                ) : (
                                    <>
                                        Thông báo mới
                                    </>
                                )
                            }
                        </CardHeader>
                        <CardBody className="pt-1">
                            {
                                this.props.notifications.length ? (
                                    <ul className="all-inverted timeline">
                                       { this.ScrollbarsNotification() }
                                    </ul>
                                ) : (
                                    <div className="text-center text-danger">
                                        Không có thông báo mới
                                    </div>
                                )
                            }
                            
                        </CardBody>
                    </Card>
                </div>
                <div className="col-xl-12 col-md-12">
                    <Card>
                        <CardHeader className="font-weight-bold">
                            Hướng dẫn
                        </CardHeader>
                        <CardBody className="pt-1">
                            <ul className="all-inverted timeline">
                                { this.ScrollbarsTutorial() }
                            </ul>
                        </CardBody>
                    </Card>
                </div>
            </div>
        )
    }

    ScrollbarsTutorial = () => {
        if (!this.state.home.tutorial.error) {
            return (
                <Scrollbars style={{ width: 'auto', minHeight: 250 }}>
                    {
                        this.state.home.tutorial.list.map( (tutorial, key) => (
                            <li className="timeline-inverted" key={key}>
                                <a href={ tutorial.link } target="_blank" rel="noreferrer">
                                    { tutorial.title }
                                </a>
                            </li>
                        ))    
                    }
                </Scrollbars>
            )
        }
    }

    render() {
        console.log(this.props.user)
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Xin chào, " + this.props.user.name} page={"Khu vực khách hàng"} icon={<FaUsers className="breadcrumb-icon"/>} />

                            {
                                this.state.error ? (
                                    <Alert color="danger">
                                        { this.state.messageError }
                                    </Alert>
                                ) : (
                                    <div className="row">
                                        <div className="col-md-12">
                                            {
                                                this.checkNotification()
                                            }
                                            {
                                                this.state.errorNotification ? (

                                                    <Alert color="danger">
                                                        { this.state.messageErrorNotification }
                                                    </Alert>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                            {
                                                this.state.successNotification ? (

                                                    <Alert color="success">
                                                        { this.state.messageSuccessNotification }
                                                    </Alert>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </div>

                                        <div className="col-12">
                                            {/* Thông kê tài khoản */}
                                            <div className="row">
                                                {/* Tổng dịch vụ */}
                                                <div className="col-xl-3 col-md-6 col-6">
                                                    <div className="card border-left-primary shadow">
                                                        <div className="card-body p-sm-3 p-2">
                                                            <div
                                                                className="row no-gutters align-items-center total_services">
                                                                <div className="col mr-2">
                                                                    <div className="text-xs font-weight-bold mb-1">
                                                                        Dịch vụ
                                                                    </div>
                                                                    <div className="text-secondary card-title font-weight-bold">
                                                                        { this.state.home.home.qtt_service }
                                                                    </div>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <FaCalendar style={ iconStyles } />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*  Số dư tài khoản  */}
                                                <div className="col-xl-3 col-md-6 col-6">
                                                    <div className="card border-left-primary shadow">
                                                        <div className="card-body p-sm-3 p-2">
                                                            <div
                                                                className="row no-gutters align-items-center total_services">
                                                                <div className="col mr-2">
                                                                    <div className="text-xs font-weight-bold mb-1">
                                                                        Tài khoản
                                                                    </div>
                                                                    <div className="text-secondary card-title font-weight-bold">
                                                                        { this.addCommas( this.props.credit ) } ₫
                                                                    </div>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <FaDollarSign style={ iconStyles } />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*  Dịch vụ chờ tạo  */}
                                                <div className="col-xl-3 col-md-6 col-6">
                                                    <div className="card border-left-primary shadow">
                                                        <div className="card-body p-sm-3 p-2">
                                                            <div
                                                                className="row no-gutters align-items-center total_services">
                                                                <div className="col mr-2">
                                                                    <div className="text-xs font-weight-bold mb-1">
                                                                        Dịch vụ chờ tạo
                                                                    </div>
                                                                    <div className="text-secondary card-title font-weight-bold">
                                                                        { this.state.home.home.qtt_processing }
                                                                    </div>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <FaCloud style={ iconStyles } />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*  Hỗ trợ  */}
                                                <div className="col-xl-3 col-md-6 col-6">
                                                    <div className="card border-left-primary shadow">
                                                        <div className="card-body p-sm-3 p-2">
                                                            <div
                                                                className="row no-gutters align-items-center total_services">
                                                                <div className="col mr-2">
                                                                    <div className="text-xs font-weight-bold mb-1">
                                                                        Hỗ trợ
                                                                    </div>
                                                                    <div className="text-secondary card-title font-weight-bold">
                                                                        { this.state.home.home.qtt_ticket }
                                                                    </div>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <FaComment style={ iconStyles } />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Home Page Left */}
                                        <div className="col-lg-12 col-xl-8">
                                            
                                            {/* Thông kê dịch vụ */}
                                            <div className="row">
                                                <div className="col-md-12 col-lg-6 mb-3">
                                                    <Card className="h-100">
                                                        <CardHeader className="font-weight-bold">
                                                            Thống kê dịch vụ
                                                        </CardHeader>
                                                        <CardBody>
                                                            { this.ScrollbarsService() }
                                                        </CardBody>
                                                    </Card>
                                                </div>
                                                {/*Dịch vụ hết hạn và gần hết hạn*/}
                                                {
                                                    !this.state.isLoadNearly ? (
                                                        <>
                                                            {/*VPS*/}
                                                            {
                                                                this.props.vps && !this.state.serviceNearly.vps.error ? (
                                                                    <div className="col-md-12 col-lg-6 mb-3">
                                                                        <Card className="h-100">
                                                                            <CardHeader className="font-weight-bold">
                                                                                 Dịch vụ VPS hết hạn
                                                                            </CardHeader>
                                                                            <CardBody>
                                                                                {/*this.state.serviceNearly.vps.expire*/}
                                                                                Quý khách có {" "}
                                                                                {
                                                                                    this.state.serviceNearly.vps.using ? (
                                                                                        <>
                                                                                            { this.state.serviceNearly.vps.using } dịch vụ VPS gần hết hạn {" "}
                                                                                            {
                                                                                                this.state.serviceNearly.vps.expire ? (
                                                                                                    <>
                                                                                                        và { this.state.serviceNearly.vps.expire } dịch vụ VPS đã hết hạn.{" "}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <></>
                                                                                                )
                                                                                            }
                                                                                        </>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    this.state.serviceNearly.vps.expire ? (
                                                                                        <>
                                                                                            { this.state.serviceNearly.vps.expire } dịch vụ VPS đã hết hạn.
                                                                                        </>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }
                                                                                {" "}Khi hết hạn chúng tôi sẽ tạm dừng sản phẩm/dịch vụ đó{" "}
                                                                                và xóa trong vòng 3-7 ngày tính từ ngày hết hạn.{" "}
                                                                                Quý khách vui lòng gia hạn để không bị gián đoạn dịch vụ!{" "}
                                                                                <Link to={"/dich-vu-vps/dich-vu-gan-het-han-va-da-het-han.html"}>Xem chi tiết</Link>
                                                                            </CardBody>
                                                                        </Card>
                                                                    </div>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                            {/*VPS US*/}
                                                            {
                                                                this.props.vps_us && !this.state.serviceNearly.vps_us.error ? (
                                                                    <div className="col-md-12 col-lg-6 mb-3">
                                                                        <Card className="h-100">
                                                                            <CardHeader className="font-weight-bold">
                                                                                 Dịch vụ VPS US hết hạn
                                                                            </CardHeader>
                                                                            <CardBody>
                                                                                {/*this.state.serviceNearly.vps.expire*/}
                                                                                Quý khách có {" "}
                                                                                {
                                                                                    this.state.serviceNearly.vps_us.using ? (
                                                                                        <>
                                                                                            { this.state.serviceNearly.vps_us.using } dịch vụ VPS gần hết hạn {" "}
                                                                                            {
                                                                                                this.state.serviceNearly.vps_us.expire ? (
                                                                                                    <>
                                                                                                        và { this.state.serviceNearly.vps_us.expire } dịch vụ VPS đã hết hạn.{" "}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <></>
                                                                                                )
                                                                                            }
                                                                                        </>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    this.state.serviceNearly.vps_us.expire ? (
                                                                                        <>
                                                                                            { this.state.serviceNearly.vps_us.expire } dịch vụ VPS đã hết hạn.
                                                                                        </>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }
                                                                                {" "}Khi hết hạn chúng tôi sẽ tạm dừng sản phẩm/dịch vụ đó{" "}
                                                                                và xóa trong vòng 3-7 ngày tính từ ngày hết hạn.{" "}
                                                                                Quý khách vui lòng gia hạn để không bị gián đoạn dịch vụ!{" "}
                                                                                <Link to={"/dich-vu-vps-us/dich-vu-gan-het-han-va-da-het-han.html"}>Xem chi tiết</Link>
                                                                            </CardBody>
                                                                        </Card>
                                                                    </div>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                            {/*CloudServer*/}
                                                            {
                                                                this.props.cloudServer && !this.state.serviceNearly.cloud_server.error ? (
                                                                    <div className="col-md-12 col-lg-6 mb-3">
                                                                        <Card className="h-100">
                                                                            <CardHeader className="font-weight-bold">
                                                                                Dịch vụ Cloud Server hết hạn
                                                                            </CardHeader>
                                                                            <CardBody>
                                                                                {/*this.state.serviceNearly.vps.expire*/}
                                                                                Quý khách có {" "}
                                                                                {
                                                                                    this.state.serviceNearly.cloud_server.using ? (
                                                                                        <>
                                                                                            { this.state.serviceNearly.cloud_server.using } dịch vụ Cloud Server gần hết hạn {" "}
                                                                                            {
                                                                                                this.state.serviceNearly.cloud_server.expire ? (
                                                                                                    <>
                                                                                                        và { this.state.serviceNearly.cloud_server.expire } dịch vụ Cloud Server đã hết hạn.{" "}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <></>
                                                                                                )
                                                                                            }
                                                                                        </>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    this.state.serviceNearly.cloud_server.expire ? (
                                                                                        <>
                                                                                            { this.state.serviceNearly.cloud_server.expire } dịch vụ Cloud Server đã hết hạn.
                                                                                        </>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }
                                                                                {" "}Khi hết hạn chúng tôi sẽ tạm dừng sản phẩm/dịch vụ đó{" "}
                                                                                và xóa trong vòng 3-7 ngày tính từ ngày hết hạn.{" "}
                                                                                Quý khách vui lòng gia hạn để không bị gián đoạn dịch vụ!{" "}
                                                                                <Link to={"/dich-vu-cloud-server/dich-vu-gan-het-han-va-da-het-han.html"}>Xem chi tiết</Link>
                                                                            </CardBody>
                                                                        </Card>
                                                                    </div>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                            {/*Hosting*/}
                                                            {
                                                                this.props.hosting && !this.state.serviceNearly.hosting.error ? (
                                                                    <div className="col-md-12 col-lg-6 mb-3">
                                                                        <Card className="h-100">
                                                                            <CardHeader className="font-weight-bold">
                                                                                Dịch vụ Hosting hết hạn
                                                                            </CardHeader>
                                                                            <CardBody>
                                                                                {/*this.state.serviceNearly.vps.expire*/}
                                                                                Quý khách có {" "}
                                                                                {
                                                                                    this.state.serviceNearly.hosting.using ? (
                                                                                        <>
                                                                                            { this.state.serviceNearly.hosting.using } dịch vụ Hosting gần hết hạn {" "}
                                                                                            {
                                                                                                this.state.serviceNearly.hosting.expire ? (
                                                                                                    <>
                                                                                                        và { this.state.serviceNearly.hosting.expire } dịch vụ Hosting đã hết hạn.{" "}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <></>
                                                                                                )
                                                                                            }
                                                                                        </>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    this.state.serviceNearly.hosting.expire ? (
                                                                                        <>
                                                                                            { this.state.serviceNearly.hosting.expire } dịch vụ Hosting đã hết hạn.
                                                                                        </>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )
                                                                                }
                                                                                {" "}Khi hết hạn chúng tôi sẽ tạm dừng sản phẩm/dịch vụ đó{" "}
                                                                                và xóa trong vòng 5-10 ngày tính từ ngày hết hạn.{" "}
                                                                                Quý khách vui lòng gia hạn để không bị gián đoạn dịch vụ!{" "}
                                                                                <Link to={"/dich-vu-vps/dich-vu-gan-het-han-va-da-het-han.html"}>Xem chi tiết</Link>
                                                                            </CardBody>
                                                                        </Card>
                                                                    </div>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        </>
                                                    ) : (
                                                        <></>
                                                    )
                                                }

                                                {/* Biểu đồ thống kê VPS*/}
                                                {
                                                    this.props.vps && !this.state.home.service.vps.error ? (
                                                        <div className="col-md-12 col-lg-6 mb-3">
                                                            <Card className="h-100">
                                                                <CardHeader className="font-weight-bold">
                                                                    Biểu đồ dịch vụ VPS
                                                                </CardHeader>
                                                                <CardBody>
                                                                    <Pie data={ this.state.dataChartVps } />
                                                                </CardBody>
                                                            </Card>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                {/* Biểu đồ thống kê Proxy*/}
                                                {
                                                    this.props.proxy && !this.state.home.service.proxy.error ? (
                                                        <div className="col-md-12 col-lg-6 mb-3">
                                                            <Card className="h-100">
                                                                <CardHeader className="font-weight-bold">
                                                                    Biểu đồ dịch vụ Proxy
                                                                </CardHeader>
                                                                <CardBody>
                                                                    <Pie data={ this.state.dataChartProxy } />
                                                                </CardBody>
                                                            </Card>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                            </div>
                                            {/* Biểu đồ thống kê */}
                                            <div className="row">
                                                
                                                {
                                                    <div className="col-md-12">
                                                        <Card>
                                                            <CardHeader className="font-weight-bold">
                                                                Biểu đồ số dư tài khoản
                                                            </CardHeader>
                                                            <CardBody>
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <Pie data={ this.state.dataChartCredit } />
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <Table className="table table-hover table-bordered">
                                                                            <thead className="primary">
                                                                            <tr>
                                                                                <th>Loại</th>
                                                                                <th>Số tiền</th>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            <tr>
                                                                                <td>Tổng tiền</td>
                                                                                <td>{ this.addCommas( this.state.home.credit.total ) } ₫</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Số dư</td>
                                                                                <td>{ this.addCommas( this.state.home.credit.credit ) } ₫</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Đã dùng</td>
                                                                                <td>{ this.addCommas( this.state.home.credit.total_total_expenses ) } ₫</td>
                                                                            </tr>
                                                                            </tbody>
                                                                        </Table>
                                                                    </div>
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        {/* Home Page Right */}
                                        <div className="col-lg-12 col-xl-4">
                                            { this.loadHompageRight() }
                                        </div>
                                    </div>
                                )
                            }

                        </>
                    )
                }
            </>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        vps: state.system.vps,
        vps_us: state.system.vps_us,
        proxy: state.system.proxy,
        cloudServer: state.system.cloudServer,
        hosting: state.system.hosting,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,

        notifications: state.user.notifications,
        unread_notification: state.user.unread_notification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerHome' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
        updateMenuCustomer: (item) => {
            dispatch(({ type : 'updateMenuCustomer', item }))
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
